// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1QLyo","studentIconContainer":"styles_studentIconContainer__2WZKn","subTitle":"styles_subTitle__3BPKk"};